module.exports = __webpack_public_path__ + "static/assets/a4ac3d9c54c820531c0c8d55a4563782.svg";